import React from 'react';
import SectionHeader from '../components/SectionHeader';
import BarGallery from '../components/BarGallery';

const BarPage: React.FC = () => {
  return (
    <div className="pt-20 bg-primary-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <SectionHeader
          eyebrow="THE BAR"
          title="Our Bar"
          subtitle="Relax and unwind at The Creamery Bar with our extensive selection of drinks, from craft beers to fine spirits"
          darkMode={true}
        />

        <div className="mt-12">
          <div>
            <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">
              A Welcoming Atmosphere
            </h3>
            <p className="text-gray-300 mb-6">
              Whether you're stopping by for a quick pint after work or settling in for an evening with friends, 
              The Creamery Bar offers a warm and inviting atmosphere. Our bar features a carefully curated selection 
              of beverages to suit every taste.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="text-primary-gold mr-3">✓</span>
                <span className="text-gray-300">Wide selection of craft beers and lagers</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-gold mr-3">✓</span>
                <span className="text-gray-300">Premium spirits and cocktails</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-gold mr-3">✓</span>
                <span className="text-gray-300">Wines and soft drinks</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-gold mr-3">✓</span>
                <span className="text-gray-300">Comfortable seating and friendly service</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-gold mr-3">✓</span>
                <span className="text-gray-300">Sports viewing on large screens</span>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 mb-12">
            <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-8 shadow-2xl">
              <h4 className="text-2xl font-bold text-primary-gold mb-4 font-display">Opening Hours</h4>
              <div className="space-y-2 text-gray-300">
                <p className="flex justify-between">
                  <span>Monday - Sunday:</span>
                  <span className="text-primary-gold">11am - 11pm</span>
                </p>
              </div>
            </div>

            <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-8 shadow-2xl">
              <h4 className="text-2xl font-bold text-primary-gold mb-4 font-display">What's On</h4>
              <div className="space-y-2 text-gray-300">
                <p>Live sports coverage</p>
                <p>Weekly specials and promotions</p>
                <p>Perfect for group gatherings</p>
              </div>
            </div>
          </div>

          <div className="bg-primary-black border border-primary-gold/20 rounded-lg p-8 shadow-2xl text-center">
            <h4 className="text-2xl font-bold text-primary-gold mb-4 font-display">Visit Us Today</h4>
            <p className="text-gray-300 mb-4">
              Join us at The Creamery Bar for great drinks, good company, and a fantastic atmosphere. 
              Whether you're watching the game or catching up with friends, we've got you covered.
            </p>
          </div>
        </div>

        <BarGallery />
      </div>

      {/* Reservation CTA Section */}
      <section className="relative py-20 bg-primary-black overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-gold opacity-5 rounded-full blur-3xl"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-gold mb-6 font-display">
            Visit The Bar
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Drop by for a drink or call ahead for group bookings
          </p>
          <a 
            href="/book" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
            aria-label="Contact us for bar inquiries and group bookings"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default BarPage;
